const serverURL = "https://bot-designer-server-2.azurewebsites.net/api";
const livechatURL = "https://i2i-test.azurewebsites.net/api/";

export { serverURL, livechatURL };
